module.exports = __webpack_public_path__ + "static/media/resources.b032158d.png";